import { EMarkAllAsReadNotificationActionTypes, TMarkAllAsReadNotificationSucceed } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const markAllAsReadSucceed: () => TMarkAllAsReadNotificationSucceed =
  actionGenerator<EMarkAllAsReadNotificationActionTypes.Succeed>(EMarkAllAsReadNotificationActionTypes.Succeed);
